import { useCurrentUser } from '../../currentUser';

export const useShouldShowTerms = () => {
  const currentUser = useCurrentUser();

  return currentUser && currentUser.hasAccess && currentUser.needsToAcceptTerms;
};
